import moment from "moment";
import React, { Component } from 'react';
import styled from 'styled-components';
import { TimeDisplay } from 'core/Display';
import OrderListItem from './OrderListItem';

const Slots = styled.div`
  display: grid;
  gap: 4px;
  min-width: 180px;
`;

const SlotCard = styled.div`
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  
  &.hasOrder {
    background: #fff8e1;
    border-color: #f5d76e;
    cursor: pointer;
    
    &:hover {
      border-color: #e6c04a;
      background: #fff3c4;
    }
  }
  &.status-WORKING {
    background: #edf8ee;
    border-color: #b7dfb9;
  }
  &.status-NOT_WORKING {
    background: #fdecec;
    border-color: #f0b4b4;
  }
  &.isSelected {
    box-shadow: 0 0 0 2px #fec108;
  }
`;

const SlotInner = styled.div`
  display: grid;
  grid-template-columns: 4px 1fr;
`;

const SlotAccent = styled.div`
  background: #bdbdbd;
  
  .hasOrder & {
    background: #fec108;
  }
  .status-WORKING & {
    background: #43a047;
  }
  .status-NOT_WORKING & {
    background: #e53935;
  }
`;

const SlotBody = styled.div`
  padding: 4px 8px;
  min-width: 0;
`;

const SlotHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
`;

const SlotTime = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
`;

const SlotStatus = styled.div`
  font-size: 12px;
  color: #828282;
  white-space: nowrap;
`;

const SlotComment = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: #828282;
`;


const SwitchToEndOfTheDay = (props) => {
  const { date_start, date } = props;
  if (moment(date_start).day() !== moment(date).day()) {
    return (
      <React.Fragment>23:59</React.Fragment>
    )
  }
  return (
    <React.Fragment>
      <TimeDisplay value={date} />
    </React.Fragment>
  )
}


export default class TableSlots extends Component {
  getStatusLabel = (info, order) => {
    if (order) {
      return null;
    }
    if (info.schedule_status === 'NOT_WORKING') {
      return 'Не работает';
    }
    return 'Свободно';
  };

  render() {
    const { info, items, previewId, onPreview } = this.props;

    if (items === undefined || items.length === 0) {
      return '—';
    }

    return (
      <Slots>
        {items.map(item => {
          const order = item.order;
          const isSelected = order && previewId !== undefined && String(previewId) === String(order.id);
          let className = order ? 'hasOrder' : `status-${info.schedule_status}`;
          if (isSelected) {
            className += ' isSelected';
          }
          const statusLabel = this.getStatusLabel(info, order);
          return (
            <SlotCard
              key={item.id}
              className={className}
              onClick={order ? () => onPreview && onPreview(order) : undefined}
            >
              <SlotInner>
                <SlotAccent />
                <SlotBody>
                  <SlotHead>
                    <SlotTime>
                      <TimeDisplay value={item.date_start} />
                      {' – '}
                      <SwitchToEndOfTheDay date={item.date_end} date_start={item.date_start} />
                    </SlotTime>
                    {statusLabel && <SlotStatus>{statusLabel}</SlotStatus>}
                    {order && (
                      <OrderListItem
                        slot={item}
                        order={order}
                        previewId={previewId}
                        onPreview={onPreview}
                        compact={true}
                      />
                    )}
                  </SlotHead>
                  {item.comment && (
                    <SlotComment>{item.comment}</SlotComment>
                  )}
                </SlotBody>
              </SlotInner>
            </SlotCard>
          )
        })}
      </Slots>
    );
  }
}
